import type { JSX } from 'solid-js';
import { cx } from '../cx';
import type { ClassMap } from './variant';

// A small bordered label — "planned", "most popular". Anything unshipped gets a
// bordered chip, never an accent fill: `solid` is an INK fill, and there is no
// variant that reaches the working hue. The height is a minimum
// (`--ui-chip-block`), never fixed, so a longer Spanish label wraps instead of
// clipping.
export type ChipVariant = 'outline' | 'solid';

export type ChipProps = {
  readonly variant?: ChipVariant;
  readonly children: JSX.Element;
};

export const CHIP_VARIANT_CLASS: ClassMap<ChipVariant> = {
  outline: 'ui-chip--outline',
  solid: 'ui-chip--solid',
};

export function Chip(props: ChipProps): JSX.Element {
  return (
    <span class={cx('ui-chip', CHIP_VARIANT_CLASS[props.variant ?? 'outline'])}>
      {props.children}
    </span>
  );
}
